// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6152":"558d7cbdb6ca1035","7647":"bb316c81c50a5d4c"}[chunkId] + ".css";
};